import React from 'react';

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-24 bg-white" data-testid="how-it-works">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-gray-900">
            Simple as <span className="gradient-text">1, 2, 3</span>.
          </h2>
        </div>
        
        <div className="grid grid-cols-3 gap-4 sm:gap-8 lg:gap-12">
          <div className="text-center">
            <div className="w-10 h-10 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-black text-white rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-6 text-lg sm:text-xl lg:text-2xl font-bold">
              1
            </div>
            <h3 className="text-sm sm:text-lg lg:text-xl font-semibold mb-1 sm:mb-2"><span className="gradient-text">Download</span></h3>
            <p className="text-gray-500 text-xs sm:text-sm lg:text-base">Get the app free on iOS or Android.</p>
          </div>
          
          <div className="text-center">
            <div className="w-10 h-10 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-black text-white rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-6 text-lg sm:text-xl lg:text-2xl font-bold">
              2
            </div>
            <h3 className="text-sm sm:text-lg lg:text-xl font-semibold mb-1 sm:mb-2"><span className="gradient-text">Explore</span></h3>
            <p className="text-gray-500 text-xs sm:text-sm lg:text-base">Use the tools as you need them.</p>
          </div>
          
          <div className="text-center">
            <div className="w-10 h-10 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-black text-white rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-6 text-lg sm:text-xl lg:text-2xl font-bold">
              3
            </div>
            <h3 className="text-sm sm:text-lg lg:text-xl font-semibold mb-1 sm:mb-2"><span className="gradient-text">Build</span></h3>
            <p className="text-gray-500 text-xs sm:text-sm lg:text-base">Make confident decisions.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
